<div class="sip-pitch-card">
  <div class="head">
    <div *ngIf="config?.userdata?.aggdonationall?.funds <= 1" class="desc"><div class="text"><strong>300 kids</strong> are still suffering due to a lack of financial support. Help them receive timely medical treatment.</div></div>
    <div *ngIf="config?.userdata?.aggdonationall?.funds > 1" class="desc"><div class="text">Donate seamlessly and help <strong>underprivileged children</strong> receive immediate medical treatment.</div></div>
    <div class="image">
      <img loading="lazy" data-src="/assets/images/father.png" alt="father"></div>
  </div>

  <div class="pitch">
    <div class="heading">
      <div *ngIf="config?.userdata?.aggdonationall?.funds <= 1" class="text">Help such kids with the Social Impact Plan</div>
      <div *ngIf="config?.userdata?.aggdonationall?.funds > 1" class="text">Hassle-free donations with the Social Impact Plan</div>
      <div class="amount"><app-currency-icon class="icon" *ngIf="config?.currency" [currency]="config?.currency"></app-currency-icon>{{paymentV2.getMinSipAmount(config?.currency)?.amount}}<span>/mo</span> </div>
    </div>

    <div class="extra-info">
      <div *ngFor="let info of infoText" class="info">
        <span class="material-icons">check</span><span>{{info?.text}}</span>
      </div>
    </div>

    <div *ngIf="config?.currency" class="payment-button">
      <app-payment-sip-dialog-btn [config]="
        {
          dialogBtnTheme: 'payment-btn-v1',
          amount: paymentV2.getMinSipAmount(config?.currency)?.amount,
          currency: config?.currency,
          dialogBtnLabel: 'Start Giving ' + paymentV2.getMinSipAmount(config?.currency)?.text + '/mo',
          origin: config?.origin,
          hideDockBtn: true,
          redirectTo: 'standalone',
          hideCardInfo: config?.currency==='INR' ? true : false,
          one_tap_pay: config?.currency!=='INR' ? true : false,
          show_one_tap_otp: config?.currency!=='INR' ? true : false,
          sip_wallet: 0,
          dialogBtnSkipFailed: true,
          systemEvent: { eventName: 'give_monthly_new', info_3: 'impact' }
        }">
      </app-payment-sip-dialog-btn>
      <app-payment-sip-donors></app-payment-sip-donors>
    </div>

    <div class="offer-note">
      <app-offer-note [v2]="true"></app-offer-note>
    </div>

  </div>
</div>


